var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 8.33331C3.25 8.33331 2.5 9.08331 2.5 9.99998C2.5 10.9166 3.25 11.6666 4.16667 11.6666C5.08333 11.6666 5.83333 10.9166 5.83333 9.99998C5.83333 9.08331 5.08333 8.33331 4.16667 8.33331Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 8.33331C14.917 8.33331 14.167 9.08331 14.167 9.99998C14.167 10.9166 14.917 11.6666 15.8337 11.6666C16.7503 11.6666 17.5003 10.9166 17.5003 9.99998C17.5003 9.08331 16.7503 8.33331 15.8337 8.33331Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 8.33331C9.08301 8.33331 8.33301 9.08331 8.33301 9.99998C8.33301 10.9166 9.08301 11.6666 9.99967 11.6666C10.9163 11.6666 11.6663 10.9166 11.6663 9.99998C11.6663 9.08331 10.9163 8.33331 9.99967 8.33331Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMore);
export default __webpack_public_path__ + "static/media/menu-more.b10935387d0def7473ea4f8c9480c95a.svg";
export { ForwardRef as ReactComponent };